import { HistoryListPresenter } from '@/presentation/presenters/history/historyListPresenter'
import { HistoryListViewModel } from '@/presentation/viewmodels/history/historyListViewModel'

export function useHistoryListPresenter(
  presenter: HistoryListPresenter = new HistoryListPresenter(new HistoryListViewModel())
) {
  return {
    historyList: presenter.historyList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    hasHistoryInList: presenter.hasHistoryInList,
    fetchHistoryList: presenter.fetchHistoryList.bind(presenter)
  }
}
